import React from "react";
import { Helmet } from "react-helmet";
import TopNavbar from "../Nav/TopNavbar";
import Footer from "../Sections/Footer";
import Whatsapp from "../whatsapp/whatsapp";

const SITE_URL = "https://finechek.com";

export default function PageLayout({ title, description, path, offsetTop = true, children }) {
  const url = `${SITE_URL}${path}`;
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
      </Helmet>
      <TopNavbar />
      <Whatsapp />
      <main style={{ paddingTop: offsetTop ? "80px" : 0 }}>{children}</main>
      <Footer />
    </>
  );
}
